module.exports = __webpack_public_path__ + "static/commerce2x-multi-stores-inventory-62f93cb9efb15dc3acef090d63bfa535.png";